module.exports = __webpack_public_path__ + "img/mastercard.cea68f33.png";